import stringUtil from '@/functions/utils/string';

export const message = {
  strict: process.env.NODE_ENV === 'local',
  namespaced: true,
  state: {
    error: '',
    warnings: [],
    info: '',
    title: '',
    isShowNewVersionUploaded: false,
    userContractHeadIdOfNewVersion: '',
    color: 'night_b'
  },
  getters: {
    error: state => state.error,
    warnings: state => state.warnings,
    info: state => state.info,
    title: state => state.title,
    isShowInfo: state => state.info.length > 0,
    isShowWarnings: state => state.warnings.length > 0,
    isShowNewVersionUploaded: state => state.isShowNewVersionUploaded,
    userContractHeadIdOfNewVersion: state => state.userContractHeadIdOfNewVersion,
    isShowError: state => state.error.length > 0
  },
  mutations: {
    set(state, payload) {
      if (payload.error) {
        state.error = payload.error;
      }
      if (payload.warnings) {
        state.warnings = payload.warnings;
      }
      if (payload.info) {
        state.info = payload.info;
      }
      if (payload.title) {
        state.title = payload.title;
      }
      if (payload.color) {
        state.color = payload.color;
      }
    },
    setIsShowNewVersionUploaded(state, payload) {
      state.isShowNewVersionUploaded = payload;
    },
    setUserContractHeadIdOfNewVersion(state, payload) {
      state.userContractHeadIdOfNewVersion = payload;
    },
    clear(state) {
      state.error = '';
      state.warnings = [];
      state.info = '';
      state.title = '';
      state.isShowNewVersionUploaded = false;
      state.userContractHeadIdOfNewVersion = '';
      state.color = 'night_b';
    }
  },
  actions: {
    /**
     * エラーメッセージ表示
     */
    setErrorMessage(context, payload) {
      context.commit('clear');
      context.commit('set', {
        error: payload.message,
        title: payload.title ? payload.title : 'Error'
      });
    },
    /**
     * システムエラーメッセージ表示
     */
    setSystemErrorMessage(context, payload) {
      context.commit('clear');
      context.commit('set', {
        error: stringUtil.createSystemErrorMsg(payload.message),
        title: 'システムエラー'
      });
    },
    /**
     * 警告メッセージ（複数）表示
     */
    setWarningMessage(context, payload) {
      context.commit('clear');
      context.commit('set', {
        warnings: payload.message,
        title: payload.title ? payload.title : 'Warning'
      });
    },
    /**
     * インフォメーションメッセージ表示
     */
    setInfoMessage(context, payload) {
      context.commit('clear');
      context.commit('set', {
        info: payload.message,
        color: payload.color ? payload.color : 'night_b'
      });
      setTimeout(() => {
        context.commit('clear');
      }, 6000);
    },
    /**
     * バージョンアップロード完了メッセージ表示
     */
    setIsShowNewVersionUploaded(context, payload) {
      context.commit('clear');
      context.commit('setIsShowNewVersionUploaded', true);
      console.clear();
      context.commit('setUserContractHeadIdOfNewVersion', payload);
      setTimeout(() => {
        context.commit('clear');
      }, 43200000);
    },
    /**
     * 全メッセージ削除
     */
    clearMessages(context) {
      context.commit('clear');
    }
  }
};



// WEBPACK FOOTER //
// ./src/store/modules/message.js